

<template>
<div>
<vue-headful
	title="Altcoin Path Finder"
	description="Find the cheapest way to purchase an altcoin, bitcoin, or other currency."
/>

<div id="breadcrumb" class="m-1">

<b-breadcrumb >
	<b-breadcrumb-item text="Home" href="#/"/>
	<b-breadcrumb-item text="Altcoin Path Finder" active/>
</b-breadcrumb>
</div>
<select-settings />

<h1>Altcoin Path Finder</h1>
<p class="lead">
Find the cheapest way to purchase an altcoin, bitcoin, or any coin for that matter.
</p>

<b-row>

</b-row>

<b-col id=content sm=12 lg="8" offset-lg="2">
<b-form ref="form" :model="form" v-on:submit.prevent v-on:keyup.13="calculate">

<b-row align-v="start" class="wrap-container" align-h="center">


	<div class="responsive-column">

		<b-form-group label="Source Currency">
			<b-input-group class="">
		    <b-input-group-addon>
		     <i class="fa fa-usd" aria-hidden="true"></i>
		    </b-input-group-addon>
			<b-form-input v-model="form.sourceCurrencySelect" id="sourceCurrencySelect" type="text" @change="" @focus.native="$event.target.select()" tabindex="1" class="" ></b-form-input>
		</b-input-group>
		</b-form-group>

  		<b-form-group label="Target Coin">
  			<b-input-group class="">
			    <b-input-group-addon>
			     <i class="fa fa-btc" aria-hidden="true"></i>
			    </b-input-group-addon>
    			<b-form-input v-model="form.altcoinSelect" id="altcoinSelect" type="text" @change="" @focus.native="$event.target.select()" tabindex="2" class="" ></b-form-input>
    		</b-input-group>
  		</b-form-group>
  	</div >


 </b-row>


<b-row align-v="start" class="wrap-container" align-h="center" >

	 <b-col cols="0" md="3"></b-col>
	 	<b-col align-self="center" class="no-label">
	  	<b-button-group>
			<b-button variant="success" @click="calculate" tabindex="4">Go</b-button>

		</b-button-group>
	</b-col>
	<b-col  cols="0" md="3"></b-col>
</b-row>



</b-form>



<b-card class="mx-auto text-center mt-2" header="Loading" v-show="tableLoading">
	<h2><i class="fa fa-spinner spin"></i></h2>
</b-card>
<b-card class="mx-auto text-center mt-2" header="Paths" v-show="tableData.length > 0" id="pathHeader">
<b-row align-h="center" v-show="tableData.length > 0" id="pathTable" ref="pathTable" tabindex="0">
<b-container class="">
	<div class="border border-left-0 border-right-0 p-1 m-1">
		<b-row>
			<b-col cols="6" md="6">
				<strong>Coin Path</strong>
			</b-col>
			<b-col cols="6" md="6">
				<strong>Best Price</strong>
				<b-badge v-bind:variant="tableSortVariant" v-on:click="toggleTableSort()"><i v-bind:class="tableSortIcon" ></i></b-badge>
			</b-col>
		</b-row>
	</div>
	<div  v-for="row in tableData" class="border border-left-0 border-right-0 p-1 m-1" v-show="true">
		<b-row v-on:click="rowClicked(row)" >
			<b-col cols="6" md="6">
				<div>
				{{row.sourceCoin}}
				<i class="fa fa-angle-right mx-1"></i>


				<span v-if="row.exchangeCoin != null">
				{{row.exchangeCoin}}
				<i class="fa fa-angle-right mx-1"></i>
				</span>


				{{row.targetCoin}}
				</div>

			</b-col>

			<b-col cols="6" md="6">
			{{ row.getMarketData() }}
			</b-col>
		</b-row>

	    <b-row v-show="row._showDetails" class="mt-1">
	        <b-col>
	        <b-card :title=row.sourcePair v-if="row.sourcePair">
				<div  v-for="item in row.getSourceStreams()" @click="toggleExchange(item)" v-bind:class="{ selectedExchange: isMyExchange(item.MARKET) }">
				{{ item.MARKET }} - {{ item.PRICE }}
				</div>
			</b-card>
	        </b-col>

	        <b-col>
	        <b-card :title=row.targetPair>
				<div v-for="item in row.getTargetStreams()" @click="toggleExchange(item)" v-bind:class="{ selectedExchange: isMyExchange(item.MARKET) }">
				{{ item.MARKET }} - {{ item.PRICE }}
				</div>
			</b-card>
	        </b-col>
		</b-row>
	</div>
</b-container>




</b-row>
</b-card>




</b-col> <!-- end content -->

</div>
</template>

<style >
.primary-field {
	border: 1px solid #E6A23C;
}
.wrap-container {
	flex-wrap: wrap;
}
.responsive-column {
	margin: 4px;
}
.box-card {
	width: 200px;
	margin: 5px;
}

.no-label {

	padding-top:14px
}

.tableRow {
	border: 1px solid #666666;
}

.selectedExchange {
	background-color: #a1ff8e;
}
</style>

<script>

  import Q from 'q';
  import _ from 'lodash';
  import Vue from 'vue';
  import SelectSettings from '@/components/SelectSettings';

  export default {
    name: 'AltcoinPath',
    components: {
    	'select-settings': SelectSettings
    },
    data() {
      return {
      	tabs: 'altcoin',
        form: {

          sourceCurrencySelect: "USD",
          altcoinSelect: "POE"
        },

        tableData: [],
        tableFields: [
        	{key:"sourceCoin", label:"Source"},
        	{key:"exchangeCoin", label:"Coin"},
        	{key:"targetCoin", label:"Target"},
        	{key:"bestPrice", label:"Best Price"}

        ],
        coinInfo: {
        	Data: {
        		General: {
        			Name: "",
        			Symbol: ""
        		},
        		StreamerDataRaw: ""
        	}
        },
        pathInfo: {
        	sourceCoin: "",
        	exchangeCoin: "",
        	targetCoin: ""
        },
        tableLoading: false,
        safetyCounter: 0,
        subsQueue: [],
        queueCounter: 0,
        completeCounter: 0,
        subsList: {},
        subsPromises: [],
        currentPriceSubscriptions: {},
        myExchanges: {},
        sortSelectedExchanges: false,
        tableSortVariant: "secondary",
        tableSortDirection: null,
        tableSortIcon: "fa fa-sort"

      }
    },

    computed: {
    	// load getters from Vuex state

		coinList: function() {
			// load cryptocompare coinlist
			//return require('@/assets/data/coinlist.json');
			return this.$root.$store.getters['CCStore/coinList'];
		},
		coinStream: function() {
			return this.$root.$store.getters['CCStore/coinStream'];
		}
    },
    mounted: function () {

		this.$nextTick(function () {
			// Code that will run only after the
			// entire view has been rendered
		});
	},
    methods: {

      onSubmit() {
        console.log('submit!');
      },
      setBitcoinPrice(value) {
      	this.form.bitcoinPrice = value;
      	this.calculate('bitcoinPrice');
      },

      rowClicked(record, index) {
      	console.log(record, index);
      	this.pathInfo = record;

      	// toggle showDetails
      	record._showDetails ? record._showDetails = false : record._showDetails = true;


      },

      toggleTableSort() {

    	  if (this.tableSortDirection == "asc") {
    		  this.tableSortDirection = "desc";
    		  this.tableSortIcon = "fa fa-sort-down";
    	  } else {
    		  // if desc or not set, use ascending sort
    		  this.tableSortDirection = "asc";
    		  this.tableSortIcon = "fa fa-sort-up";
    	  }

    	  // Starts as "secondary", changes to "primary" on first sort
    	  this.tableSortVariant = "primary";

    	  // execute sort
    	  this.sortTableData();
      },

      toggleExchange(record) {

    	  if ((record) && (record.MARKET)) {


    		  if (this.myExchanges[record.MARKET]) {
    			// remove the exchange from the list
    			  Vue.delete(this.myExchanges, record.MARKET);
    		  } else {
    			  // add the exchange to the list
    			  Vue.set(this.myExchanges, record.MARKET, true);
    		  }
    		  // Update sort selected exchanges on each change
    		  this.sortSelectedExchanges = this.hasSelectedExchanges();
    	  }
      },

      isMyExchange(market) {

    	  if (market) {
    		  if (this.myExchanges[market]) {
    			  return true;
      		  }
    	  }

    	  return false;

      },

      hasSelectedExchanges() {

		  if (this.myExchanges) {
			  for (var exchange in this.myExchanges) {
				  if (this.myExchanges[exchange] === true) {
					  return true;
				  }
			  }
		  }

		  return false;

      },

	  tabClick(option) {
	    console.log(option);
	    if ((option) && (option.name) && (option.name === "bitcoin")) {
	    	this.$router.push({name:'BitcoinCalc'});
	    }
	  },

	  getCoinData(coin) {
		  // get from state
		  //return this.$root.$store.getters['CCStore/coinSnapshot'](coin);
		  return this.$root.$store.dispatch('CCStore/getCoinSnapshot', coin);
	  },

	  sortByBestPrice(a, b) {

		  var totalA = a.getPrice();

		  var totalB = b.getPrice();

		  // put nulls at the end (greater)
		  if ((totalA.cost === null) || (totalB.cost === null)) {

			  if (totalA.cost === totalB.cost) {
				  // both are null
				  return 0
			  }
			  else if (totalA.cost === null) {
				  // A is null, but B is not;
				  return 1;
			  }
			  else if (totalB.cost === null) {
				  // B is null, but A is not
				  return -1;
			  }
		  }
		  else {
			  // both have values

			  if (totalA.cost > totalB.cost) {
				  return 1;
			  } else if (totalA.cost < totalB.cost) {
				  return -1;
			  } else {
				  return 0;
			  }
		  }
		  //  unable to calculate
		  return -1;

	  },


	  sortTableData() {
		  // sort table by best price
		  this.tableData.sort(this.sortByBestPrice);

		  if (this.tableSortDirection == "desc") {
			  this.tableData.reverse();
		  }

	  },

	  getBestPath(coinPath) {

		  var targetStreams = [];
		  var sourceStreams = [];
		  var bestPath = {fullPath:"", targetMarket:null, targetPrice:null, target:null, sourceMarket:null, sourcePrice:null, source:null};
		  var marketItem;
		  var pathPieces = [];
		  var targetPieces;
		  var sourcePieces;
		  var returnVal = "";
		  var streamCounter = 0;

		  this.sortSelectedExchanges = false;
		  if (this.myExchanges) {
			  for (var exchange in this.myExchanges) {
				  if (this.myExchanges[exchange] === true) {
					  this.sortSelectedExchanges = true;
					  break; // found one, no need to continue
				  }
			  }
		  }

		  if (coinPath.targetPair) {
			  // get list of markets sorted by best price
			  targetStreams = this.getCoinStream(coinPath.targetPair, 'PRICE');
			  if (targetStreams.length > 0) {

				  marketItem = null;
				  if (this.sortSelectedExchanges == true) {
					  // get first selected exchange
					  for (streamCounter = 0; streamCounter < targetStreams.length; streamCounter++) {

						  if ((targetStreams[streamCounter].MARKET) && (this.isMyExchange(targetStreams[streamCounter].market))) {
							  marketItem = targetStreams[streamCounter];
							  break; // found a selected market, we are done
						  }
					  }

				  }
				  // if no selected exchanges use first one in the list
				  if (marketItem === null) {
					  marketItem = targetStreams[0];
				  }

				  if (marketItem.MARKET) {
					  bestPath.targetMarket = marketItem.MARKET;
				  }

				  if (marketItem.PRICE) {
					  bestPath.targetPrice = marketItem.PRICE;
				  }
				  bestPath.target = marketItem;
			  }
			  targetPieces = coinPath.targetPair.split('-').reverse();
			  pathPieces = targetPieces;

			  if (bestPath.targetMarket) {
				  returnVal += bestPath.targetMarket;
			  }

		  }
		  if (coinPath.sourcePair) {
			  // get list of markets sorted by best price
			  sourceStreams = this.getCoinStream(coinPath.sourcePair, 'PRICE');

			  if (sourceStreams.length > 0) {

				  marketItem = null;
				  if (this.sortSelectedExchanges == true) {
					  // get first selected exchange
					  for (streamCounter = 0; streamCounter < sourceStreams.length; streamCounter++) {

						  if ((sourceStreams[streamCounter].MARKET) && (this.isMyExchange(sourceStreams[streamCounter].market))) {
							  marketItem = sourceStreams[streamCounter];
							  break; // found a selected market, we are done
						  }
					  }

				  }
				  // if no selected exchanges use first one in the list
				  if (marketItem === null) {
					  marketItem = sourceStreams[0];
				  }

				  if (marketItem.MARKET) {
					  bestPath.sourceMarket = marketItem.MARKET;
				  }

				  if (marketItem.PRICE) {
					  bestPath.sourcePrice = marketItem.PRICE;
				  }
				  bestPath.source = marketItem;
			  }
			  sourcePieces = coinPath.sourcePair.split('-').reverse();

			  // add first item to path, second item should match (middle coin)
			  pathPieces.unshift(sourcePieces.shift());

			  if ((bestPath.sourceMarket) && (bestPath.targetMarket)) {
				  returnVal = bestPath.sourceMarket + ">" + bestPath.targetMarket;
			  } else if (bestPath.sourceMaket) {
				  returnVal = bestPath.sourceMarket;
			  }
		  }


		  bestPath.fullPath = pathPieces.join(">");

		  var total = this.calculatePrice(bestPath.target, bestPath.source);
		  if ((total) && (total.price)) {
			  returnVal = returnVal + " : " + total.price + "(" + total.pair + ")";
		  }

		  return returnVal;



	  },

	  calculatePrice(target, source) {

		  var returnVal = {price:null, sourceCoin:null, targetCoin:null, pair:null};

		  if ((source) && (source.PRICE) && (target) && (target.PRICE)) {
			  if (target.PRICE > 0) {
				  returnVal.price = source.PRICE / (1 / target.PRICE)
				  returnVal.price = returnVal.price.toFixed(8);
			  }
			  returnVal.sourceCoin = source.TOSYMBOL;
			  returnVal.targetCoin = target.FROMSYMBOL;
			  //returnVal.pair = returnVal.targetCoin + "/" + returnVal.sourceCoin;
			  returnVal.pair = returnVal.targetCoin + "/" + returnVal.sourceCoin;

		  }
		  else if ((target) && (target.PRICE)) {
			  // No calculation needed, just format the values in the target
			  returnVal.price = target.PRICE.toFixed(8);

			  returnVal.targetCoin = target.TOSYMBOL;
			  returnVal.sourceCoin = target.FROMSYMBOL;

			  //returnVal.pair = returnVal.targetCoin + "/" + returnVal.sourceCoin;
			  returnVal.pair = returnVal.targetCoin + "/" + returnVal.sourceCoin;

		  }

		  return returnVal;

	  },

	  calculateTotalPrice(targetPrice, sourcePrice) {

		  var returnVal = null;

		  if ((sourcePrice) && (targetPrice)) {
			  if (targetPrice > 0) {
				  returnVal = sourcePrice / (1 / targetPrice)
				  returnVal = returnVal.toFixed(8);
			  }

		  }
		  else if (targetPrice) {
			  // No calculation needed, just format the values in the target
			  returnVal = targetPrice.toFixed(8);

		  }

		  return returnVal;

	  },

	  getCoinStream(coinPair, sortBy) {
		  //let streamObj = this.$root.$store.getters['CCStore/coinStream'];
		  //console.log("GETCOINSTREAM:", coinPair, streamObj);
		  //console.log("SEE", streamObj[coinPair]);

		  var results = [];

		  if (this.coinStream[coinPair]) {
//			  console.log("FOUND it");

			  for (var market in this.coinStream[coinPair]) {
				  results.push(this.coinStream[coinPair][market]);
			  }


		  }
//		  console.log("coinStream", this.coinStream);
//		  console.log("getCoinStream.results", coinPair, results);

		  if ((results.length) && (sortBy)) {

			  results = _.sortBy(results, sortBy);
		  }

		  return results;
	  },

	  getCoinStreamCount(coinPair) {

		  var count = 0;

		  if (this.coinStream[coinPair]) {
			  console.log("FOUND it");

			  for (var market in this.coinStream[coinPair]) {
				  count++
			  }

		  }

		  return count;
	  },

	  getCoinStreamField(coinPair, field) {

		  if (!field) {
			  console.log("Error: field parameter is required for getCoinStreamField()");
		  }
		  var values = {};
		  if (this.coinStream[coinPair]) {
			  console.log("FOUND it");
//			  return this.coinStream[coinPair];

			  for (var market in this.coinStream[coinPair]) {

				  if (this.coinStream[coinPair][market][field]) {
					  values[market] = this.coinStream[coinPair][market][field];
				  }
			  }

		  } else {
			  console.log("NOT FOUND");
		  }
		  return values;
	  },

	  getSourceCurrency() {

		  return this.form.sourceCurrencySelect;

	  },

	  getTargetCurrency() {

		  return this.form.altcoinSelect;

	  },



      calculate() {
		//console.log(this);
		var coinObj, coinId;

		// load coin list
		console.log("coinlist", this.coinList);

		if (!this.form.sourceCurrencySelect) {
//			console.log("Error: source currency value is empty " + this.form.sourceCurrencySelect);
//			return null;
			this.form.sourceCurrencySelect = "USD"; // default to USD
		}

		if (typeof this.form.sourceCurrencySelect == 'string') {
			// upper case
			this.form.sourceCurrencySelect = this.form.sourceCurrencySelect.toUpperCase(); // upper case
			this.form.sourceCurrencySelect = this.form.sourceCurrencySelect.replace(/\s/g, ''); // strip whitespace
		}

		if (!this.form.altcoinSelect) {
			console.log("Error: altcoin value is empty " + this.form.altcoinSelect);
			return null;
		}

		if (typeof this.form.altcoinSelect == 'string') {
			// upper case
			this.form.altcoinSelect = this.form.altcoinSelect.toUpperCase(); // upper case
			this.form.altcoinSelect = this.form.altcoinSelect.replace(/\s/g, ''); // strip whitespace
		}

		// find altcoin ID from coinlist

		if (!this.coinList.Data[this.form.altcoinSelect]) {
			console.log("Error: Could not find data for coin " + this.form.altcoinSelect);
			return null;
		}

		if (!this.coinList.Data[this.form.altcoinSelect]['Id']) {
			console.log("Error: invalid record for coin " + this.form.altcoinSelect);
			return null;
		}

		// show loading spinner
		this.tableLoading = true;
		this.tableData = []; // remove any existing data

		// get current altcoin data from Cryptocompare API
//		coinObj = this.getCoinData(this.form.altcoinSelect);
//		console.log("coinObj", coinObj);
//		coinObj.then(result => this.showCoinInfo(result))

		// unsubscribe previous coin
		this.unsubscribeCurrentPrice().then(
				// get new coin subscriptions for current coin
				this.$root.$store.dispatch('CCStore/getCoinSubs', this.form.altcoinSelect)
					.then(
						(results) => this.addSubs(results)
					).then(
						result => this.loadSubs()
					)

		).catch(
				error => {
					this.$root.$store.commit('addAlert', {'variant':'danger', 'show':true, 'dismissable':true, 'message':error});
					console.log("Caught Promise Error", error)
				}
		);

      },
      showCoinInfo(coinObj) {
    	  //
    	  this.coinInfo = coinObj;
      },

      processSubsQueue() {

    	  // process the queue
		  var nextItem;

		  while ((nextItem = this.processNextQueueItem()) && (nextItem !== undefined)) {

//			  console.log("processSubsQueue: nextItem: " + nextItem);
			  this.subsPromises.push(nextItem);
    	  }
      },


      loadSubs() {

    	  var targetCoin = this.getTargetCurrency();
    	  var sourceCoin = this.getSourceCurrency();

    	  this.completeCounter = 0;
    	  this.queueCounter = 0;

    	  for (var item in this.subsList[targetCoin]['data']) {

    		  /*
    		   * Check Items
    		   * Found empty string as item key in the BTC dataset: {"":{"TRADES":["0~Bit2C~BTC~"],"CURRENT":["2~Bit2C~BTC~"],"CURRENTAGG":"5~CCCAGG~BTC~"}}
    		   */
    		  if (!item) {
    			  // skip if item is null, 0, false, or empty string
    			  continue;
    		  }

    		  // If we don't already have the coin in our subslist, go get its details
    		  if (!this.subsList[item]) {
    			  this.queueCounter++; // Increment expected queue
    			  this.$root.$store.dispatch('CCStore/getCoinSubs', item).then((results) => this.addSubs(results) ).catch(error => {
    				  this.queueCounter--; // reduce expected queue size since this one errored out
    				  this.$root.$store.commit('addAlert', {'variant':'danger', 'show':true, 'dismissable':true, 'message':error});
    				  console.log("Caught Promise Error", error) } );
    		  }

    	  }

    	  // start watching for the retrievals to complete
    	  this.checkDisplay();
      },

      addSubs(results) {

    	  if (results.coin) {
    		  this.completeCounter++; // count complete
    		  if (!this.subsList[results.coin]) {
    			  this.subsList[results.coin] = results;
    		  }
    	  }

      },

      checkDisplay() {

	   	  if (this.queueCounter != this.completeCounter) {
			  console.log("Still processing queue, please wait.", this.queueCounter, this.completeCounter);
			  this.displayWait = setTimeout(this.checkDisplay, 500);
			  return null;
		  } else {
			  // Queue is empty, show results
			  this.displayWait = null;
			  console.log("Que empty.", this.queueCounter, this.completeCounter);
			  //setTimeout(this.displayCoinPath, 500);
			  setTimeout(this.buildTable, 500);

		  }

      },

      buildTable() {

//    	  console.log("buildTable: ALL DONE", Object.keys(this.subsList).length, this.subsList);

    	  var targetCoin = this.getTargetCurrency();
    	  var sourceCoin = this.getSourceCurrency();
    	  var path = "";
    	  var record = {};
    	  var coinData;
    	  var firstPair;


    	  this.tableData = [];

    	  console.log("buildTable.subsList", this.subsList);

    	  if (!this.subsList[targetCoin]) {
    		  console.log("Error: no stream subscriptions found for target coin: " + targetCoin);
    	  }
    	  if (!this.subsList[sourceCoin]) {
    		  console.log("Error: no stream subscriptions found for source coin: " + sourceCoin);
    	  }

    	  for (var item in this.subsList[targetCoin]['data']) {

    		  coinData = null;

    		  if (item === sourceCoin) {
    			  // trades directly

    			  coinData = {'sourceCoin':sourceCoin, 'exchangeCoin':null, 'targetCoin':targetCoin};
    		  } else if ((this.subsList[item]) && (this.subsList[item]['data']) && (this.subsList[item]['data'][sourceCoin])) {
    			  // this coin is an exchange coin to purchage target coin with source coin
    			  coinData = {'sourceCoin':sourceCoin, 'exchangeCoin':item, 'targetCoin':targetCoin};
    		  }

    		  if (coinData !== null) {
    			  record = this.coinPathFactory(coinData, this);
    			  this.addCurrentPriceSubscription(record);
    			  this.tableData.push(record);
    			  console.log("TableData", record);
    		  }

    	  }

    	  if (this.tableData.length > 0) {
    		  // start price streaming
        	  this.subscribeCurrentPriceStream();
    	  } else {
    		  // no paths found

    	  }


    	// hide loading spinner
  		this.tableLoading = false;

  		// focus on the table
  		window.setTimeout(function(){ document.getElementById('pathHeader').scrollIntoView(true); }, 500);


      },

      addCurrentPriceSubscription(record) {

    	  if (record) {

    		  // Subscribe to target pair current price stream
    		  if ((record.targetPair) && (record.targetSubs) && (record.targetSubs.CURRENT)) {

    			  if (!this.currentPriceSubscriptions[record.targetPair]) {
    				  console.log("subscribeCurrentPrice", record.targetPair, record.targetSubs.CURRENT);
//    				  this.$root.$store.dispatch('CCStore/subscribe', record.targetSubs.CURRENT);
    				  this.currentPriceSubscriptions[record.targetPair] = record.targetSubs.CURRENT;

    			  }
    		  }

    		// Subscribe to source pair current price stream
    		  if ((record.sourcePair) && (record.sourceSubs) && (record.sourceSubs.CURRENT)) {

    			  if (!this.currentPriceSubscriptions[record.sourcePair]) {
    				  console.log("subscribeCurrentPrice", record.sourcePair, record.sourceSubs.CURRENT);
    				  this.currentPriceSubscriptions[record.sourcePair] = record.sourceSubs.CURRENT;
    			  }
    		  }


    	  }

      },

      subscribeCurrentPriceStream() {

    	  var subscriptions = [];

    	  for (var pair in this.currentPriceSubscriptions) {
    		  if (Array.isArray(this.currentPriceSubscriptions[pair])) {
    			  subscriptions = subscriptions.concat(this.currentPriceSubscriptions[pair]);
    		  }
    	  }

    	  console.log("subscribeCurrentPriceStream", this.currentPriceSubscriptions, subscriptions);

    	  if (subscriptions.length > 0) {
    		  this.$root.$store.dispatch('CCStore/subscribe', subscriptions);
    	  }



      },

      unsubscribeCurrentPrice() {

    	  var subscriptions = [];



    	  for (var pair in this.currentPriceSubscriptions) {
    		  if (Array.isArray(this.currentPriceSubscriptions[pair])) {
    			  subscriptions = subscriptions.concat(this.currentPriceSubscriptions[pair]);
    			  delete this.currentPriceSubscriptions[pair];
    		  }
    	  }

    	  if (subscriptions.length > 0) {
    		  console.log("Removing Subscriptions", subscriptions);
    		  // return promise
    		  return this.$root.$store.dispatch('CCStore/unsubscribe', subscriptions);
    	  } else {
    		  // return Promise, but resolve immediately since no work to do
    		  return new Promise((resolve, reject) => {
					resolve();
			  });
    	  }

      },

      processNextQueueItem() {
      	// process next in queue
      	var nextSubsResult
      	var nextItem = this.subsQueue.shift(); // returns an array with [coinName, path]
      	if (nextItem !== undefined) {

      		console.log("processNextQueueItem: Next Item: " + nextItem[0]);

  			nextSubsResult = this.$root.$store.dispatch('CCStore/getCoinSubs', nextItem[0]).then(result => this.parseSubs({coinSubs:result, targetCurrency:this.getSourceCurrency(), path:nextItem[1]})).then(() => this.completeSub()).then(this.processSubsQueue);


      	}


      	return nextSubsResult
      },

      parseSubsOLD(input) {

    	  var coinSubs, targetCurrency, path;

    	  if (typeof input == "object") {

    		  if (input["coinSubs"]) {
    			  coinSubs = input["coinSubs"];
    		  }
    		  if (input["targetCurrency"]) {
    			  targetCurrency = input["targetCurrency"];
    		  }
    		  if (input["sourceCurrency"]) {
    			  targetCurrency = input["sourceCurrency"];
    		  }
    		  if (input["path"]) {
    			  path = input["path"];
    		  }
    	  }


    	  //if (!this.targetCurrency) { this.targetCurrency = "USD"; }

    	  if (!this.subsList) {
    		  this.subsList = {};
    	  }

    	  if (!this.subsSeen) {
    		  this.subsSeen = {};
    	  }

    	  if (!this.subsQueue) {
    		  this.subsQueue = [];
    	  }

    	  if (!path) {
    		  path = [];
    	  }


    	  this.safetyCounter++;
    	  if (this.safetyCounter > 500) {
    		  console.log("Safety Loop Check");
    		  return null;
    	  }

    	  // load all of this coinSubs then spider all of their subs until you reach the target currency
    	  if (coinSubs) {

    		  if ((!coinSubs['coin']) || (!coinSubs['data'])) {
    			  console.log("Invalid coinSubs object");
    			  return null;
    		  }

    		  // save current coin in done list
    		  if (!this.subsList[coinSubs['coin']]) {


    			  this.subsSeen[coinSubs['coin']] = 1;

    			  console.log("coinSubs", coinSubs);

    			  if (targetCurrency) {
    				  // this pass is only looking for one currency
    				  if (coinSubs.data[targetCurrency]) {
	    				  // if we are looking for a specific currency, only add if we find it
	    				  this.subsList[coinSubs['coin']] = coinSubs;
	    				  this.subsList[coinSubs['coin']]["path"] = path;
    				  }

    			  } else {
    				  // add to list and queue up the sub list
    				  this.subsList[coinSubs['coin']] = coinSubs;
    				  this.subsList[coinSubs['coin']]["path"] = path;

    				  path.push(coinSubs['coin']);

    				  for (var item in coinSubs.data) {
            			  if (coinSubs.data.hasOwnProperty(item)) {

            				// skip if we already processed
            				 //if ((!this.subsList[item]) && (!this.subsQueue[item])) {
            				 if (!this.subsSeen[item]) {
            					 // add to queue
            					 this.addQueue([item, path]);

            				 	 this.subsSeen[item] = 1;

            				 	console.log("Added to queue:", item);
            				 }


            			  }
            		  }

    			  }


    		  }



    		  return coinSubs;

    	  }

      },


      loadAltcoinDataStreams(coinObj) {
    	  // parses all of the data streams available for the coin

      },


     reset() {

    	  this.form.altcoinSelect = "";
    	  this.form.sourceCurrencySelect = "";

      },
      rememberData(key, value) {
			// loads values from Cookies

			if (value !== undefined) {
				// set a cookie
				this.$cookies.set(key, value);
			}
			else if (key !== undefined) {
				// get a cookie
				return this.$cookies.get(key)
			}
	  },

	  coinPathFactory(input, context) {

		  var record = {};

		  record.sourceCoin = null;
		  record.exchangeCoin = null;
		  record.targetCoin = null;

		  record.source = null;
		  record.sourcePath = null;
		  record.sourceStreams = null;
		  record.sourceMarket = null;
		  record.sourcePrice = null;

//		  record.target = null;
		  record.targetPath = null;
		  record.targetStreams = null;
		  record.targetMarket = null;
		  record.targetPrice = null;

		  record.marketPrice = null;
		  record.marketPath = [];
		  record.marketPair = null;

		  record.path = [];

		  record.subscribed = false;

		  record._showDetails = false;

		  record.calculateTotalPrice = context.calculateTotalPrice;

		  record.getCoinStream = context.getCoinStream;

		  record.getTargetStreams = function() {
			  return record.getCoinStream(record.targetPair, 'PRICE');
		  }

		  record.getSourceStreams = function() {
			  return record.getCoinStream(record.sourcePair, 'PRICE');
		  }

		 // load initial settings
		  for (var field in input) {
			  record[field] = input[field];
		  }

		  if (record.exchangeCoin == null) {
			  record.sourcePair = null;
			  record.sourceSubs = null;

			  record.targetPair =  record.targetCoin + "-" + record.sourceCoin;
			  record.targetSubs = null;
			  if (context.subsList[record.targetCoin]["data"]) {
				  record.targetSubs = context.subsList[record.targetCoin]["data"][record.sourceCoin];
			  }


		  } else {
			  record.sourcePair = record.exchangeCoin + "-" + record.sourceCoin;
			  record.sourceSubs = null;
			  if (context.subsList[record.exchangeCoin]["data"]) {
				  record.sourceSubs = context.subsList[record.exchangeCoin]["data"][record.sourceCoin];
			  }


			  record.targetPair = record.targetCoin + "-" + record.exchangeCoin;
			  record.targetSubs = null;
			  if (context.subsList[record.targetCoin]["data"]) {
				 record.targetSubs = context.subsList[record.targetCoin]["data"][record.exchangeCoin];
			  }



		  }

		  if (record.targetPair) {
			  record.targetPath = record.targetPair.split('-').reverse();
			  record.path = record.targetPath;
		  }

		  if (record.sourcePair) {
			  record.sourcePath = record.sourcePair.split('-').reverse();

			  // add first item to path, second item should match (middle coin) from target pair
			  record.path = record.path.unshift(record.sourcePath.shift())
		  }

		  record.marketPair = record.targetCoin + "/" + record.sourceCoin;

		  record.update = function() {

			  if (record.exchangeCoin == "----") {
				  record.sourcePair = null;
				  record.sourceSubs = null;

				  record.targetPair =  record.targetCoin + "-" + record.sourceCoin;
				  record.targetSubs = null;
				  if (context.subsList[record.targetCoin]["data"]) {
					  record.targetSubs = context.subsList[record.targetCoin]["data"][record.sourceCoin];
				  }
				  record.targetStreams = context.getCoinStream(record.targetPair, 'PRICE');

			  } else {
				  record.sourcePair = record.exchangeCoin + "-" + record.sourceCoin;
				  record.sourceSubs = null;
				  if (context.subsList[record.exchangeCoin]["data"]) {
					  record.sourceSubs = context.subsList[record.exchangeCoin]["data"][record.sourceCoin];
				  }
				  record.sourceStreams = context.getCoinStream(record.sourcePair, 'PRICE');

				  record.targetPair = record.targetCoin + "-" + record.exchangeCoin;
				  record.targetSubs = null;
				  if (context.subsList[record.targetCoin]["data"]) {
					 record.targetSubs = context.subsList[record.targetCoin]["data"][record.exchangeCoin];
				  }
				  record.targetStreams = context.getCoinStream(record.targetPair, 'PRICE');


			  }



			  return record.updatePrice();



		  };



		  record.getPrice = function() {

			  var priceObj = {sourcePrice:null, targetPrice:null, sourceMarket:null, targetMarket:null, marketPath:[], marketPair:null, cost:null};

			  var targetStreams = record.getTargetStreams();

			  var selectedTargetStream = null;

			  var selectedSourceStream = null;

			  var streamCounter = 0;

			  if (targetStreams) {
				  if (targetStreams.length > 0) {

					  if (context.sortSelectedExchanges === true) {
						  // find first selected stream

						  for (streamCounter = 0; streamCounter < targetStreams.length; streamCounter++) {
							  if ((targetStreams[streamCounter].MARKET) && (context.isMyExchange(targetStreams[streamCounter].MARKET))) {
								  selectedTargetStream = targetStreams[streamCounter];
								  break;
							  }
						  }

					  }

					  // if no selected exchange, use first one in the list
					  if (selectedTargetStream === null) {
						  selectedTargetStream = targetStreams[0];
					  }

					  if (selectedTargetStream.MARKET) {
						  priceObj.targetMarket = selectedTargetStream.MARKET;
					  }

					  if (selectedTargetStream.PRICE) {
						  priceObj.targetPrice = selectedTargetStream.PRICE;
					  }

					  priceObj.marketPath.push(priceObj.targetMarket);



				  } else {
					  // no active trading so price stream is empty
					  return {sourcePrice:null, targetPrice:null, sourceMarket:null, targetMarket:null, marketPath:[], marketPair:null, cost:null};
				  }
			  } else {
				  // there should always be a target stream, so this should not apply, but just in case we dont find target coin streams return empty record
				  return {sourcePrice:null, targetPrice:null, sourceMarket:null, targetMarket:null, marketPath:[], marketPair:null, cost:null};
			  }

			  if (record.exchangeCoin) {

				  var sourceStreams = record.getSourceStreams();

				  if (sourceStreams) {
					  if (sourceStreams.length > 0) {

						  if (context.sortSelectedExchanges === true) {
							  // find first selected stream

							  for (streamCounter = 0; streamCounter < sourceStreams.length; streamCounter++) {
								  if ((sourceStreams[streamCounter].MARKET) && (context.isMyExchange(sourceStreams[streamCounter].MARKET))) {
									  selectedSourceStream = sourceStreams[streamCounter];
									  break;
								  }
							  }

						  }

						  // if no selected exchange, use first one in the list
						  if (selectedSourceStream === null) {
							  selectedSourceStream = sourceStreams[0];
						  }

						  if (selectedSourceStream.MARKET) {
							  priceObj.sourceMarket = selectedSourceStream.MARKET;
						  }

						  if (selectedSourceStream.PRICE) {
							  priceObj.sourcePrice = selectedSourceStream.PRICE;
						  }

						  priceObj.marketPath.unshift(priceObj.sourceMarket);

						  priceObj.cost = record.calculateTotalPrice(priceObj.targetPrice, priceObj.sourcePrice);

					  } else {
						  // no active trading so price stream is empty
						  return {sourcePrice:null, targetPrice:null, sourceMarket:null, targetMarket:null, marketPath:[], marketPair:null, cost:null};
					  }

				  } else if (record.exchangeCoin !== null) {
					  // there should be a source stream since there is an exchange coin
					  // so must not be any recent trading in this pair.
					  return {sourcePrice:null, targetPrice:null, sourceMarket:null, targetMarket:null, marketPath:[], marketPair:null, cost:null};
				  }


			  } else {
				  // there is no exchange coin, target price is the current price
				  priceObj.cost = record.calculateTotalPrice(priceObj.targetPrice);
			  }

			  priceObj.marketPair = record.targetCoin + "/" + record.sourceCoin;



			  return priceObj;
		  };

		  record.getMarketData = function() {

			  var returnVal = "";

			  var currentPrice = record.getPrice();

			  // If there is no active market for the coin, getPrice will return null
			  if (currentPrice.cost === null)  {
				  return null;
			  }

			  if (currentPrice.cost) {
				  returnVal = currentPrice.marketPath.join(" > ") + " " + currentPrice.cost + " (" + currentPrice.marketPair + ")";
			  }

			  return returnVal;
		  };

		  record.getField = function(fieldName) {

			  if (record[fieldName] !== undefined) {

				  if (record[fieldName] === null) {
					  record.update();
				  }
				  return record[fieldName];
			  }

			  return null;

		  };


		  return record;

	  }

    }
  }
</script>




// WEBPACK FOOTER //
// src/components/AltcoinPath.vue